// extracted by mini-css-extract-plugin
module.exports = {"size_select":"SizeButtonGroup_size_select__34CEu","selected":"SizeButtonGroup_selected__1B6Aq"};